import { type ClusterRead } from "src/client";
import useLocalStorage from "src/hooks/useLocalStorage";

const RECENTLY_VISITED_CLUSTER_KEY = "recentlyVisitedCluster";

export function useRecentlyVisitedCluster(): {
  updateRecentlyVisitedCluster: (cluster: ClusterRead) => void;
  getRecentlyVisitedClusterId: () => string | null;
} {
  const [lastVisitedCluster, setLastVisitedCluster] = useLocalStorage<
    string | null
  >(RECENTLY_VISITED_CLUSTER_KEY, null);

  const updateRecentlyVisitedCluster = (cluster: ClusterRead): void => {
    if (!cluster?.id) return;
    setLastVisitedCluster(cluster.id);
  };

  const getRecentlyVisitedClusterId = (): string | null => {
    return lastVisitedCluster;
  };

  return {
    updateRecentlyVisitedCluster,
    getRecentlyVisitedClusterId,
  };
}
